module.exports = __webpack_public_path__ + "img/about.190f91f5.png";